import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { getConsent, setConsent, loadGA4 } from "@/lib/cookies";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getConsent();
    if (consent === "accepted") {
      loadGA4();
    } else if (consent === null) {
      // Small delay so it doesn't flash on load
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  // Listen for re-show event from footer "Cookie Settings" link
  useEffect(() => {
    const handler = () => setVisible(true);
    window.addEventListener("show-cookie-banner", handler);
    return () => window.removeEventListener("show-cookie-banner", handler);
  }, []);

  const handleAccept = () => {
    setConsent("accepted");
    loadGA4();
    setVisible(false);
  };

  const handleDecline = () => {
    setConsent("declined");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 20, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-5 right-5 left-5 md:left-auto md:max-w-xs z-[9999]"
        >
          <div className="backdrop-blur-xl bg-foreground/[0.06] border border-foreground/[0.08] rounded-sm px-5 py-4">
            <p className="font-body text-[11px] leading-[1.7] tracking-[0.02em] text-muted-foreground mb-4">
              We use analytics cookies to learn how visitors navigate our site so we can make it better. No personal data is sold — ever.{" "}
              <a
                href="/cookies"
                className="text-foreground/60 hover:text-foreground transition-colors underline underline-offset-2 decoration-foreground/20"
              >
                Full cookie policy
              </a>
            </p>
            <div className="flex gap-2">
              <button
                onClick={handleAccept}
                className="font-body text-[10px] font-medium tracking-[0.15em] uppercase text-foreground/80 hover:text-foreground border border-foreground/15 hover:border-foreground/30 px-4 py-1.5 rounded-sm transition-all duration-300"
              >
                Accept
              </button>
              <button
                onClick={handleDecline}
                className="font-body text-[10px] font-medium tracking-[0.15em] uppercase text-muted-foreground hover:text-foreground/70 px-4 py-1.5 transition-colors duration-300"
              >
                Decline
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
